export default "__VITE_ASSET__BRuby6AA__"